// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1sM8v","modalForm":"UpgradeEpcsModal_modalForm__inSp8","modalFooter":"UpgradeEpcsModal_modalFooter__Csaoh"};